import React from 'react';
import ReactDOM from 'react-dom';
import firebase from './utils/firebase';

import 'bootstrap/dist/css/bootstrap.min.css';
import './scss/stylish-portfolio.css';

import Header from './componentsV2/header';
import HeaderSection from './componentsV2/headerSection';
import CoupleSection from './componentsV2/coupleSection';
import WeddingEventSection from './componentsV2/weddingEventSection';
import RsvpSection from './componentsV2/rsvpSection';
import FooterSection from './componentsV2/footerSection';

class App extends React.Component {
  constructor() {
    super();
    this.state = {
      user: null,
    };
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.setState({ user });
      }
    });
  }

  render() {
    const { user } = this.state;
    return (
      <div>
        <Header />
        <HeaderSection />
        <CoupleSection />
        <WeddingEventSection />
        <RsvpSection user={user} />
        <FooterSection />
      </div>
    );
  }
}

const rootElement = document.getElementById('root');
ReactDOM.render(<App />, rootElement);
